export const hreflangKeywords = {
    'es-ES': 'alquiler-temporal',
    'es-CL': 'arriendo-temporal',
    'es': 'alojamiento-temporario',
};

export const supportedHrefLanguages = Object.keys(hreflangKeywords);